const WORDS = ["Detailing", "Full Valets", "Polishing", "PPF Protection", "Window Tints", "Headlight Tints", "Dash Cams", "Fleet & Commercial", "Driveway Cleaning"];

export const Marquee = () => {
  const row = [...WORDS, ...WORDS];
  return (
    <div data-testid="marquee" className="relative z-10 overflow-hidden border-y border-[var(--line)] bg-[#0B0D11] py-5">
      <div className="marquee-track">
        {row.map((w, i) => (
          <span key={i} className="mx-6 inline-flex items-center gap-6 font-display text-lg font-800 uppercase tracking-tight text-white/85 sm:text-2xl">
            {w}
            <span className="h-1.5 w-1.5 rounded-full bg-[var(--blue-bright)]" />
          </span>
        ))}
      </div>
    </div>
  );
};
